module.exports = __webpack_public_path__ + "img/login-l-bg.afa3695d.jpg";